import React from "react";
import style from "css/layout.module.css";

function AllEqualSixteenths({
  onDrop,
  onDragOver,
  onDragLeave,
  onDragStart,
  speakerMode,
}) {
  return (
    <table
      id="allEqualSixteenths"
      className={style.template_table}
      onDrop={(e) => onDrop(e)}
      onDragOver={(e) => onDragOver(e)}
      onDragLeave={(e) => onDragLeave(e)}
      onDragStart={(e) => onDragStart(e)}
    >
      <tbody className={style.row_4}>
        <tr>
          <td
            className="endpoint_area speakerArea"
            id="16"
            draggable={speakerMode ? false : true}
            style={{
              backgroundImage: speakerMode
                ? "url('" +
                  process.env.REACT_APP_CLIENT_URL +
                  "img/layout/speaker_icon.png')"
                : "url('" +
                  process.env.REACT_APP_CLIENT_URL +
                  "img/layout/number/1.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
          <td
            className="endpoint_area"
            id="15"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/2.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
          <td
            className="endpoint_area"
            id="14"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/3.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
          <td
            className="endpoint_area"
            id="13"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/4.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
        </tr>
        <tr>
          <td
            className="endpoint_area"
            id="12"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/5.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
          <td
            className="endpoint_area"
            id="11"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/6.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
          <td
            className="endpoint_area"
            id="10"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/7.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
          <td
            className="endpoint_area"
            id="9"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/8.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
        </tr>
        <tr>
          <td
            className="endpoint_area"
            id="8"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/9.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
          <td
            className="endpoint_area"
            id="7"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/10.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
          <td
            className="endpoint_area"
            id="6"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/11.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>

          <td
            className="endpoint_area"
            id="5"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/12.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
        </tr>
        <tr>
          <td
            className="endpoint_area"
            id="4"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/13.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
          <td
            className="endpoint_area"
            id="3"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/14.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
          <td
            className="endpoint_area"
            id="2"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/15.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>

          <td
            className="endpoint_area"
            id="1"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/16.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
        </tr>
      </tbody>
    </table>
  );
}

export default AllEqualSixteenths;
